/* Manual branch switching. No autoplay; both branches remain readable without JS. */
if (!customElements.get('ways-branch-carousel')) {
  customElements.define('ways-branch-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = [...this.querySelectorAll('[data-branch-slide]')];
      this.buttons = [...this.querySelectorAll('[data-branch-index]')];
      this.controls = this.querySelector('[data-branch-controls]');
      this.status = this.querySelector('[data-branch-status]');
      if (this.slides.length < 2 || !this.controls) return;
      this.index = 0;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.show(0, false);
      this.controls.hidden = false;
      this.dataset.enhanced = 'true';
      this.querySelector('[data-branch-prev]').addEventListener('click', () => this.show(this.index - 1), {signal});
      this.querySelector('[data-branch-next]').addEventListener('click', () => this.show(this.index + 1), {signal});
      this.buttons.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.branchIndex)), {signal}));
      this.controls.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.addEventListener('pointerdown', event => {
        this.gesture = null;
        if (event.pointerType !== 'touch' || !event.isPrimary || event.target.closest('a,button,input,select,textarea')) return;
        if (!event.target.closest('[data-branch-slide]')) return;
        this.gesture = {id: event.pointerId, x: event.clientX, y: event.clientY};
      }, {signal});
      this.addEventListener('pointerup', event => {
        const start = this.gesture;
        this.gesture = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
      }, {signal});
      this.addEventListener('pointercancel', () => { this.gesture = null; }, {signal});
    }

    show(index, announce = true) {
      const next = (index + this.slides.length) % this.slides.length;
      const focusedSlide = this.slides.find(slide => slide.contains(document.activeElement));
      this.index = next;
      this.slides.forEach((slide, i) => { slide.hidden = i !== next; });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === next)));
      if (focusedSlide && focusedSlide !== this.slides[next]) this.buttons[next].focus({preventScroll: true});
      if (announce && this.status) this.status.textContent = `${this.buttons[next].textContent.trim()} · ${next + 1} / ${this.slides.length}`;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.gesture = null;
      this.slides?.forEach(slide => { slide.hidden = false; });
      if (this.controls) this.controls.hidden = true;
      delete this.dataset.enhanced;
    }
  });
}
